import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import IO from 'socket.io-client';
import QS from 'qs';
import feathers from 'feathers-client';
import feathersSocket from 'feathers-socketio';
var FeathersEvents = /*#__PURE__*/function () {
  function FeathersEvents() {
    _classCallCheck(this, FeathersEvents);
    this._handlers = new Map();
  }
  return _createClass(FeathersEvents, [{
    key: "connect",
    value: function connect(host, token, params) {
      var _this = this;
      if (this.io) {
        this.disconnect();
      }
      var url = new URL(host);
      var pathname = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
      this.io = IO(url.origin, {
        path: "".concat(pathname, "/socket.io"),
        transports: ['websocket'],
        query: params ? QS.stringify(params) : undefined
      });
      this.io.once('connect', function () {
        _this.io.emit('authenticate', {
          token: token
        }, function (result) {
          if (result.success) {
            _this._handlers.forEach(function (handlers, key) {
              var _key$split = key.split('|'),
                _key$split2 = _slicedToArray(_key$split, 2),
                service = _key$split2[0],
                event = _key$split2[1];
              handlers.forEach(function (handler) {
                _this._trySubscribe(service, event, handler);
              });
            });
            return;
          }
          console.error('Could not authenticate with event server: ', result);
        });
      });
      this.app = feathers().configure(feathersSocket(this.io));
      return this;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.io.close();
      this.io.off();
      if (this.app) {
        this.app.off();
      }
      delete this.io;
      delete this.app;
    }
  }, {
    key: "subscribe",
    value: function subscribe(service, event, handler) {
      var key = service + '|' + event;
      var handlers = this._handlers.get(key) || [];
      handlers.push(handler);
      this._handlers.set(key, handlers);
      this._trySubscribe(service, event, handler);
      return this;
    }
  }, {
    key: "_trySubscribe",
    value: function _trySubscribe(service, event, handler) {
      if (this.app) {
        this.app.service(service).on(event, handler);
      }
    }
  }]);
}();
export { FeathersEvents as default };
//# sourceMappingURL=FeathersEvents.js.map
